import { render, staticRenderFns } from "./PropertyValuation.vue?vue&type=template&id=b6fa7742&scoped=true&"
import script from "./PropertyValuation.vue?vue&type=script&lang=js&"
export * from "./PropertyValuation.vue?vue&type=script&lang=js&"
import style0 from "./PropertyValuation.vue?vue&type=style&index=0&id=b6fa7742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa7742",
  null
  
)

export default component.exports